import React from 'react';

const STYLES = {
  error: 'border-red-500 bg-red-50 text-red-700',
  success: 'border-brand-navy-deep bg-white text-brand-navy-deep',
};

// Six single-digit boxes whose border colour follows the verification state.
export default function CodeBoxes({ digits, status, refs, onChange, onKeyDown }) {
  return (
    <div className={`flex justify-center gap-2 sm:gap-3 ${status === 'error' ? 'animate-shake' : ''}`}>
      {digits.map((d, i) => (
        <input
          key={i}
          ref={(el) => (refs.current[i] = el)}
          value={d}
          inputMode="numeric"
          autoComplete={i === 0 ? 'one-time-code' : 'off'}
          aria-label={`Digit ${i + 1}`}
          disabled={status === 'checking' || status === 'success'}
          autoFocus={i === 0}
          onChange={(e) => onChange(i, e.target.value)}
          onKeyDown={(e) => onKeyDown(i, e)}
          onFocus={(e) => e.target.select()}
          className={`w-11 h-14 sm:w-12 sm:h-14 text-center text-2xl font-semibold rounded-xl border-2 outline-none transition-all duration-200 focus:ring-4 focus:ring-blue-100 ${
            STYLES[status] || (d ? 'border-blue-600 text-gray-900 bg-white' : 'border-gray-300 text-gray-900 bg-white focus:border-blue-600')
          }`}
        />
      ))}
    </div>
  );
}